<template>
	<div class="d-flex align-items-center justify-content-center error-content">
		<div class="error" >
			<FontAwesomeIcon style="color: var(--bs-danger);" :icon="['fas', 'triangle-exclamation']" size="2x" />
			
			<div v-if="pageError == '403'">
				<h6><span>Sorry, You Are Not Allowed to Access This Page.</span></h6>
			</div>
			
			<div v-else>
				<h6><span>{{pageError}}</span></h6>
				<h6><span class="p-1"></span></h6>
				<Button class="p-button-sm p-button-secondary" @click="back" label="Back"/>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
	import { defineComponent } from "vue";
	
	export default defineComponent({
		props: {
			pageError: {
				type: String,
				required: true
			}
		},
		methods: {
			back() {
				this.$emit('back-event');
			}
		}
	});
</script>